export const isDocumentVisible = (): boolean =>
  document.visibilityState !== "hidden";
